import * as React from 'react';
import { SVGProps } from 'react';

const IconInComparisonSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2h3v20H2V2zm11.404 3.56 1.414-1.414 2.121 2.122 4.243-4.243 1.414 1.414-5.657 5.657-3.535-3.535zM10 8H7v14h3V8zm2 3h3v11h-3V11zm8 3h-3v8h3v-8z" />
  </svg>
);
export default IconInComparisonSizeM;
